import { CroppedImage } from '~components/generic/image-crop/CroppedImage';
import { ThumbnailIcon } from '~components/icons';
import { LayoutVariant } from './LayoutVariant';

type ImageProps = {
  imageSrc?: string;
  crops: ImageCrops | undefined;
  variant: LayoutVariant;
};

export function Image({ imageSrc, crops, variant }: ImageProps) {
  const crop = variant === LayoutVariant.WIDE || variant === LayoutVariant.FULL ? crops?.rect : crops?.square;
  if (imageSrc && crop) {
    return <CroppedImage src={imageSrc} crop={crop} alt="Thumbnail" className="object-cover w-full h-full" />;
  }

  if (imageSrc) {
    return <img alt="" crossOrigin="anonymous" src={imageSrc} className="object-cover w-full h-full" />;
  }

  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="w-14 h-15 text-black opacity-30">
        <ThumbnailIcon />
      </div>
    </div>
  );
}
